import { render, staticRenderFns } from "./agent-brokers-index.vue?vue&type=template&id=05c9d53b"
import script from "./agent-brokers-index.vue?vue&type=script&lang=js"
export * from "./agent-brokers-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports